import "../styles/voice-message-player.scss";
import { useState } from "react";
import AudioPlayer from "./audio-player";
import actions from "../actions/actions";

export default function VoiceMessagePlayer({ message }) {
  const [audioUrl, setAudioUrl] = useState(message?.audioUrl || null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  // Voice messages are converted to audio on demand (only when the user chooses
  // to play them) instead of eagerly for every voice message on Dashboard load.
  async function loadAndPlay() {
    if (loading || audioUrl) return;
    setLoading(true);
    setError(false);
    try {
      const result = await actions.alerts.textToSpeech(
        message.messageDescription,
      );
      if (result?.success) {
        setAudioUrl(result.fileUrl);
      } else {
        setError(true);
      }
    } catch (e) {
      setError(true);
    } finally {
      setLoading(false);
    }
  }

  if (audioUrl) {
    return <AudioPlayer src={audioUrl} autoPlay={false} />;
  }

  return (
    <div
      className={`voice-message-play-trigger ${error ? "has-error" : ""}`}
      onClick={(e) => {
        e.stopPropagation();
        loadAndPlay();
      }}
    >
      <i className={`fa ${loading ? "fa-spinner fa-spin" : "fa-play"}`}></i>
      <span>
        {loading
          ? "Loading..."
          : error
            ? "Failed to load, tap to retry"
            : "Play voice message"}
      </span>
    </div>
  );
}
